/*
 * @Author: Teemo Ding
 * @Date: 2021-07-14 11:25:11
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 11:49:23
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelOrder/OrderReturnOrRefund/index.tsx
 */
import { Button, Checkbox, NumberInput, Select } from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import DroppableTable from '@/src/components/DroppableTable/DroppableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { CaretDownOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import React, { Fragment, useState } from 'react';
import SplitLine from 'src/components/SplitLine/SplitLine';
import TCModals from 'src/constrains/TermsAndConditionsSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { orderOptions, termsConditionsColumns } from '../config';
import css from '../css.module.less';

const OrderReturnOrRefund = ({
  type,
  salesChannelUuid,
  tcsOptions,
  tacs,
  tacsOnChange,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const i18nKeyMapping = {
    ['Return1']: 'salesChannelOrder.index.orderReturn',
    ['Refund1']: 'salesChannelOrder.index.orderRefund',
    ['Return2']: 'salesChannelOrder.index.enableorderreturn',
    ['Refund2']: 'salesChannelOrder.index.enableorderrefund',
    ['Return3']: 'salesChannelOrder.index.orderReturnTip',
    ['Refund3']: 'salesChannelOrder.index.orderRefundTip',
    ['Return4']: 'salesChannelOrder.index.orderReturnTermsConditions',
    ['Refund4']: 'salesChannelOrder.index.orderRefundTermsConditions',
    ['Return5']: 'salesChannelOrder.index.returnwithin',
    ['Refund5']: 'salesChannelOrder.index.refundwithin',
  };

  const [tcVisible, setTcVisible] = useState(false);

  const onOpen = () => {
    setTcVisible(true);
  };
  const handleOnTCReselect = (data) => {
    const _pWithagreenmentRequired = data.map((i) => ({
      ...i,
      salesChannelTermsConditionUuid: i.uuid,
      agreenmentRequired: i.setAgreementAsRequired,
    }));
    tacsOnChange(_pWithagreenmentRequired);
  };
  const onTCChange = (data) => {
    tacsOnChange(data);
  };
  const deleteTCFun = (uuid) => {
    const tacsList = tacs.filter((o) => o.uuid !== uuid);
    tacsOnChange(tacsList);
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.invoiceFormat}
      title={getI18n(i18nKeyMapping[`${type}1`])}>
      {tcVisible && (
        <TCModals
          tcs={tcsOptions}
          selectedItems={tacs}
          onOk={handleOnTCReselect}
          title={getI18n('salesChannelOrder.index.selectTermsConditions')}
          width={600}
          onCancel={(e) => {
            setTcVisible(false);
          }}
          visible={tcVisible}
        />
      )}
      {/*Enable Checkbox*/}
      <Form.Item noStyle name={`enableOrder${type}`} valuePropName='checked'>
        <Checkbox className={css.checkboxBox} disabled={disableEdit}>
          {getI18n(i18nKeyMapping[`${type}2`])}
        </Checkbox>
      </Form.Item>
      {/* 默认隐藏 Enable后展示*/}
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues[`enableOrder${type}`] !==
          currentValues[`enableOrder${type}`]
        }>
        {({ getFieldValue }) =>
          getFieldValue(`enableOrder${type}`) && (
            <Fragment>
              {/* Refund within */}
              <div className={css.maxNumPerProduct}>
                <span>{getI18n(i18nKeyMapping[`${type}5`])}</span>
                <Form.Item
                  name={`numOfDaysFor${type}`}
                  className={css.maxNumPerProductInput}
                  rules={[
                    { required: true, message: getI18n('general.required') },
                  ]}>
                  <NumberInput
                    min={1}
                    size='large'
                    suffix={getI18n('general.dateTime.days')}
                    disabled={disableEdit}
                  />
                </Form.Item>
                <Form.Item
                  name={`order${type}Option`}
                  className={css.maxNumPerProductInput}>
                  <Select
                    size='large'
                    disabled={disableEdit}
                    optionsList={orderOptions({ getI18n })}
                    suffixIcon={
                      <CaretDownOutlined className={css.selectIcon} />
                    }
                  />
                </Form.Item>
              </div>
              {/* Order Return or Refund Terms & Conditions */}
              <SplitLine className={css.splitLine} />
              <div className={css.termsConditions}>
                <div className={css.title}>
                  {getI18n(i18nKeyMapping[`${type}4`])}
                </div>
                {tacs && tacs.length > 0 ? (
                  <DroppableTable
                    pagination={false}
                    rowKey={'uuid'}
                    dataSource={tacs || []}
                    columns={termsConditionsColumns(deleteTCFun, { getI18n })}
                    id='StockProductSelection'
                    onTableChange={(products) => onTCChange(products)}
                  />
                ) : (
                  <div className={css.title}>
                    {getI18n(i18nKeyMapping[`${type}3`])}
                  </div>
                )}
                <Button
                  type='primary'
                  onClick={onOpen}
                  disabled={disableEdit}
                  className={css.termsConditionsBtn}>
                  {getI18n('salesChannelOrder.index.selectTermsConditions')}
                </Button>
              </div>
              <Configuration
                configStart={getI18n(
                  'salesChannelOrder.index.configurationText1',
                )}
                linkTo={`/salesChannel/legalPage/list/${salesChannelUuid}`}
                configLink={getI18n(
                  'salesChannelOrder.index.configurationText2',
                )}
                configEnd={getI18n(
                  'salesChannelOrder.index.configurationText3',
                )}
              />
            </Fragment>
          )
        }
      </Form.Item>
    </SectionWrapper>
  );
};

export default OrderReturnOrRefund;
